<div *commonUiOptionalWizardStep id="empfangsbevollmaechtigterAngaben">

    <div class="d-flex justify-content-between pt-1 mb-1x">
        <h2 *ngIf="!showMerkerParagraph183">{{ 'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.TITEL' | translate }}</h2>
        <h2
                *ngIf="showMerkerParagraph183">{{ 'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.TITEL_MERKERPARAGRAPH183' | translate }}</h2>
        <common-ui-daten-uebernahme (picked)="onEmpfangsbevollmaechtigterPicked($event)"
                                    [itemTemplate]="datenuebernahmeEmpfangsbevollmaechtigter"
                                    [items]="filteredStammdaten" [readonly]="readonly"
                                    context="Empfangsbevollmaechtigter"></common-ui-daten-uebernahme>
    </div>

    <div class="col-sm-12 p-0">
        <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.INFO' | translate"
                        type="info"></common-ui-card>
    </div>
    <div *ngIf="data.steuerberaterVollmacht && emptySteuerberater" class="col-sm-12 p-0">
        <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.LEER_STEUERBERATER' | translate"
                        type="danger"></common-ui-card>
    </div>

    <div class="mb-5x mt-3x">
        <div class="form-check">
            <input (change)="onSteuerberaterVollmachtChanged()" [(ngModel)]="data.steuerberaterVollmacht"
                   [disabled]="readonly" class="form-check-input"
                   id="steuerberaterVollmacht" type="checkbox">
            <label class="form-check-label"
                   for="steuerberaterVollmacht">{{ 'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.STEUERBERATER_VOLLMACHT' | translate }}
            </label>
        </div>

    </div>

    <div *ngIf="!data.steuerberaterVollmacht">
        <div class="mb-5x">

            <div class="form-row mb-3x">
                <label class="col-sm-4"
                       for="personenTyp">{{ 'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.PERSONENTYP_TITEL' | translate }}</label>
                <div class="col-sm-8">
                    <select
                            class="form-control"
                            id="personenTyp"
                            [(ngModel)]="data.personenTyp"
                            [disabled]="readonly"
                            (ngModelChange)="personTypeChanged($event)">
                        <option [ngValue]="undefined" selected>
                            {{ 'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.PERSONENTYP.NULL' | translate }}
                        </option>
                        <option *ngFor="let value of enumKeys(personenTypEnum)"
                                [ngValue]="personenTypEnum[value]">
                            {{ 'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.PERSONENTYP.KEY_' + personenTypEnum[value].toUpperCase() | translate }}
                        </option>
                    </select>
                </div>
            </div>

            <common-ui-personenstamm-daten *ngIf="data.personenTyp === personenTypEnum.NatPers"
                                           [(data)]="data.natuerlichePerson" [readonly]="readonly">
            </common-ui-personenstamm-daten>

            <common-ui-juristische-person *ngIf="data.personenTyp === personenTypEnum.NNatPers"
                                          [(data)]="data.juristischePerson" [readonly]="readonly">
            </common-ui-juristische-person>
        </div>

        <div *ngIf="data.personenTyp">
            <div class="mb-5x">
                <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ADRESSE.ADRESSE_TITEL' | translate }}</h2>
                <common-ui-adresserfassung
                        [(auslandsadresse)]="data.auslandsadresse"
                        [(inlandsadresse)]="data.inlandsadresse"
                        [(postfachadresse)]="data.postfachadresse"
                        [readonly]="readonly"
                        [stammdatenAuslandsAdresse]="stammdaten?.empfangsbevollmaechtigter?.auslandsadressen?.array"
                        [stammdatenInlandsadresse]="stammdaten?.empfangsbevollmaechtigter?.inlandsadressen?.array"
                        [stammdatenPostfachadresse]="stammdaten?.empfangsbevollmaechtigter?.postfachadressen?.array"
                ></common-ui-adresserfassung>
            </div>

            <div class="mb-5x">
                <h2
                        class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.KOMMUNIKATIONSMITTEL.KOMMUNIKATIONSMITTEL_TITEL' | translate }}
                </h2>
                <common-ui-kommunikationsmittel [(data)]="data.kommunikationsmittel" [readonly]="readonly"
                                                [stammdatenTelefonnummern]="stammdaten?.empfangsbevollmaechtigter?.kommunikation?.telefonnummern?.array"
                                                disableInternet="true"
                                                maxTelefonnummern="2"></common-ui-kommunikationsmittel>
            </div>
        </div>
    </div>

    <div *ngIf="showMerkerParagraph183" class="mb-5x">
        <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.GEMEIN_EMPF_BEV.TITEL' | translate }}</h2>
        <p class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.GEMEIN_EMPF_BEV.UNTERTITEL' | translate }}</p>
        <div class="form-row">
            <label class="col-sm-4 col-form-label"
                   for="gemeinEmpfBev">{{ 'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.GEMEIN_EMPF_BEV.LABEL' | translate }}
            </label>
            <div class="col-sm-8">
                <select
                        class="form-control"
                        id="gemeinEmpfBev"
                        [(ngModel)]="data.gemeinEmpfBev"
                        [disabled]="readonly">
                    <option [ngValue]="undefined"
                            selected>{{ 'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.GEMEIN_EMPF_BEV.NULL' | translate }}</option>
                    <option [ngValue]="'1'">{{ 'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.GEMEIN_EMPF_BEV.KEY_1' | translate }}</option>
                    <option [ngValue]="'2'">{{ 'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.GEMEIN_EMPF_BEV.KEY_2' | translate }}</option>
                </select>
            </div>
        </div>
    </div>

</div>

<ng-template #datenuebernahmeEmpfangsbevollmaechtigter let-item="item">
    <h4 *ngIf="!item?.natuerlichePerson && !item?.juristischePerson"
        class="list-group-item-heading">{{ 'COMMON_UI.FRAGEBOGEN.EMPFANGSBEVOLLMAECHTIGUNG.STEUERBERATER_VOLLMACHT' | translate }}
    </h4>
    <h4 *ngIf="item?.natuerlichePerson"
        class="list-group-item-heading">{{item?.natuerlichePerson?.titel}} {{item?.natuerlichePerson?.vorname}} {{item?.natuerlichePerson?.namensvorsatz}} {{item?.natuerlichePerson?.namenszusatz}} {{item?.natuerlichePerson?.nachname}}
    </h4>
    <h4 *ngIf="item?.juristischePerson"
        class="list-group-item-heading">{{item?.juristischePerson?.firmenname}}
    </h4>
</ng-template>
